var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{staticClass:"errorMessage",attrs:{"value":_vm.errorExists,"type":"error","transition":"slide-y-reverse-transition"},on:{"click":_vm.removeErrors}},[_vm._v(" "+_vm._s("ERROR: " + this.errorType + " " + this.errorMessage)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }